import React from 'react'
import WorkSectionCard from '../LandingPage/Component/WorkSectionCard'
import { Typography } from '@mui/material'

export default function TrustedBy() {
  return (
    <div className='px-6 md:px-20 py-16'>
         <Typography
            variant="h3"
            component="h2"
            fontWeight="bold"
            sx={{
                mb: 5,
                textAlign: "start",
                fontSize: { xs: "1.5rem", md: "36px" },
                fontFamily: "Monserrat, sans-serif",
            }}
            >
            Trusted By:
        </Typography>
        <WorkSectionCard />
    </div>
  )
}
